'use client';

import { useEffect } from 'react';
import { reportClientError } from '@/lib/client-log';

/**
 * Frontera de error de la aplicación. Además de no dejar la pantalla en blanco,
 * reporta el fallo con el `digest` de Next: es lo que permite empatar un error
 * que ocurrió al renderizar en el servidor con la línea que quedó en el log.
 */
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportClientError(error, { kind: 'boundary', digest: error.digest });
  }, [error]);

  return (
    <div style={{ maxWidth: 640, margin: '4rem auto', padding: '0 1.5rem' }}>
      <div className="card" style={{ padding: '2rem' }}>
        <h2 style={{ margin: '0 0 .75rem', fontSize: '1.25rem' }}>Algo falló en esta pantalla</h2>
        <p style={{ margin: '0 0 1.25rem', opacity: .8, lineHeight: 1.5 }}>
          El error quedó registrado. Puedes reintentar; si vuelve a ocurrir,
          repórtalo{error.digest ? <> con la referencia <code>{error.digest}</code></> : null}.
        </p>
        <button
          onClick={reset}
          style={{
            background: 'transparent', border: '1px solid var(--neon-cyan)', color: 'var(--neon-cyan)',
            borderRadius: '6px', cursor: 'pointer', padding: '0.45rem 1.1rem', fontSize: '0.9rem',
          }}
        >
          Reintentar
        </button>
      </div>
    </div>
  );
}
